import React, { useEffect } from 'react'

export const BasicAd = ({ slot }) => {
    useEffect(() => {
        ;(window.adsbygoogle = window.adsbygoogle || []).push({})
    }, [""])

    return (

        <ins className="adsbygoogle"
             style={{ "display": "block" , textAlign: "center"  }}
             data-ad-client="ca-pub-4274068129397983"
             data-ad-slot={slot}
             data-ad-format="auto"
             data-full-width-responsive="true"></ins>
    );
}
  
